/**
 * Mixin pour la validation des types de fichiers lors de l'upload
 * Utilisé pour factoriser la logique de validation commune à travers différents composants
 */
export default {
  methods: {
    /**
     * Valide le type de fichier et supprime automatiquement le fichier si invalide
     * @param {Object} file - Le fichier à valider
     * @param {Array} fileList - La liste des fichiers
     * @param {Array} allowedTypes - Les types MIME autorisés (ex: ['image/jpeg', 'image/png'])
     * @param {Object} options - Options de configuration
     * @param {String} options.i18nKey - Clé de traduction i18n pour le message d'erreur
     * @param {String} options.errorMessage - Message d'erreur personnalisé (utilisé si i18nKey n'est pas fourni)
     * @param {String} options.formatsList - Liste des formats pour l'affichage (ex: "JPG, PNG, WebP")
     * @returns {Boolean} - true si le fichier est valide, false sinon
     */
    validateFileType (file, fileList, allowedTypes, options = {}) {
      // Vérifier si le type de fichier est autorisé
      if (!allowedTypes.includes(file.raw.type)) {
        // Construire le message d'erreur sans afficher le format détecté
        let message = ''
        
        if (options.i18nKey) {
          // Utiliser la traduction i18n si disponible (sans passer le format détecté)
          message = this.$t(options.i18nKey) || this.$t(options.i18nKey, { formatsList: options.formatsList })
          
          // Fallback si la traduction n'existe pas
          if (!message || message === options.i18nKey) {
            message = options.errorMessage || `Format non autorisé. Formats acceptés: ${options.formatsList || 'voir documentation'}`
          }
        } else {
          // Utiliser le message d'erreur personnalisé
          message = options.errorMessage || `Format non autorisé. Formats acceptés: ${options.formatsList || 'voir documentation'}`
        }

        // Afficher le message d'erreur
        this.$message({
          message: message,
          type: 'error'
        })

        // Supprimer le fichier de la liste
        const index = fileList.findIndex(f => f.uid === file.uid)
        if (index > -1) {
          fileList.splice(index, 1)
        }

        return false
      }

      return true
    }
  }
}

